import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Map event_type to Material Icon names
const eventTypeIcons = {
  'aif-submission-started': 'play_arrow',
  'all-submitted': 'check_circle'
};

// Map event_type to icon colors
const eventTypeColors = {
  'aif-submission-started': '#1976d2',
  // blue
  'all-submitted': '#2e7d32' // green
};
function renderObject(obj) {
  return /*#__PURE__*/React.createElement("ul", null, Object.entries(obj).map(_ref => {
    let [key, value] = _ref;
    return /*#__PURE__*/React.createElement("li", {
      key: key
    }, /*#__PURE__*/React.createElement("strong", null, key, ":"), ' ', value && typeof value === 'object' ? renderObject(value) : String(value));
  }));
}
export default function ClaimerMessage(_ref2) {
  let {
    message
  } = _ref2;
  const [expanded, setExpanded] = useState(false);
  const {
    t
  } = useTranslation();
  if (!message) return /*#__PURE__*/React.createElement("div", null, "No message to display.");
  const iconName = eventTypeIcons[message.event_type] || 'info';
  console.log(message.event_timestamp);
  console.log(new Date(message.event_timestamp));
  return /*#__PURE__*/React.createElement("div", {
    onClick: () => setExpanded(!expanded),
    style: {
      position: 'relative',
      border: '1px solid #ccc',
      padding: '1rem',
      borderRadius: '8px',
      cursor: 'pointer',
      marginBottom: '1rem',
      backgroundColor: expanded ? '#f9f9f9' : '#fff'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      fontSize: '24px',
      color: eventTypeColors[message.event_type] || '#666'
    }
  }, iconName), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t('event_timestamp'), ":"), " ", createTimezonedDate(new Date(message.event_timestamp)).toCustomLocaleTimeString()), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t('event_type'), ":"), " ", t(message.event_type)), expanded && /*#__PURE__*/React.createElement("ul", {
    style: {
      marginTop: '1rem'
    }
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "id:"), " ", message.id), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "x_request_id:"), " ", message.x_request_id), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "message_id:"), " ", message.message_id), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "message_timestamp:"), " ", message.message_timestamp), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "event_id:"), " ", message.event_id), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "event_client_id:"), " ", message.event_client_id), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "event_submission_id:"), " ", message.event_submission_id), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "event_tenant_id:"), " ", String(message.event_tenant_id)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "event_financial_year_id:"), " ", message.event_financial_year_id), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "data:"), " ", renderObject(message.data))));
}